// Text in [brackets] renders in green. card defaults to 'standard'.
// banner: title and intro sit on the banner image instead of above the card.
export const formPages = [
    {
        path: '/artist-intake-form/',
        title: 'Intake [Form]',
        header: 'full',
        survey: 'fG1FpYMrDSvbhTjeBqQm',
        metaTitle: 'Artist Intake Form | 440 Artists',
        description: 'Complete your 440 Artist Intake Form so we can learn more about your story and connect you with brand deals, podcast features, and collaborations.',
    },
    {
        path: '/artist-rollout-form/',
        title: 'Artist [Rollout Form]',
        header: 'full',
        survey: 'DnIgO066liILADdD063X',
        metaTitle: 'Artist Rollout Form | 440 Artists',
        description: 'Submit your release details and assets so we can get your music moving. Start your rollout with 440 Artists.',
    },
    {
        path: '/cancel/',
        title: 'Cancel [Membership]',
        header: 'full',
        survey: 'cOAuCb2hHtdEsdAnCJSJ',
        metaTitle: 'Cancel Membership | 440 Artists',
        description: 'If you’d like to cancel your 440 membership, please complete the form below and our team will process your request shortly.',
    },
    {
        path: '/contact/',
        title: 'Contact [440]',
        header: 'full',
        form: 'B1hZbWOlXATT3J4Owidy',
        card: 'dark',
        banner: true,
        intro: [
            { text: 'Have a question or just want to get in touch?' },
            { text: "Fill out the form below and we'll get back to you shortly.", green: true },
        ],
        metaTitle: 'Contact Us | 440 Artists',
        description: "Have questions about 440 Artists membership or your application? Get in touch with our team and we'll get back to you shortly.",
    },
    {
        path: '/join/',
        title: 'Artist [Application]',
        header: 'minimal',
        survey: 'Nu2P7E93ZJuHMHYCTM9Q',
        scrollHandler: true,
        pixelEvent: ['AddToCart'],
        metaTitle: 'Apply to 440 – Music Distribution Reimagined for Independent Artists',
        description: 'Take control of your music career with 440 Artists. Apply now to distribute your music, keep 90% of royalties, and access opportunities like brand deals and live performances with REVOLT.',
    },
    {
        path: '/lam-application/',
        title: 'Artist [Submission]',
        header: 'minimal',
        survey: 'No4ani2UvRvsvhQr4p78',
        scrollHandler: true,
        metaTitle: 'Artist Submission for Labels & Managers | 440 Artists',
        description: 'Submit your artist for 440 distribution. Labels, managers, and agencies can complete this form to onboard artists and unlock exclusive opportunities.',
    },
    {
        path: '/lam-intake-form/',
        title: 'Intake [Form]',
        header: 'full',
        survey: 'Q8adepoRtkXeK4NAoYQL',
        metaTitle: 'Label & Manager Intake Form | 440 Artists',
        description: 'Complete your Intake Form so we can learn more about your story and connect you with brand deals, podcast features, and collaborations.',
    },
    {
        path: '/payment/',
        title: 'Membership [Payment]',
        header: 'minimal',
        survey: 'uTxQUEzMHk8O44t4c16i',
        card: 'wide',
        metaTitle: 'Membership Payment | 440 Artists',
        description: 'Unlock music distribution, royalties, and exclusive opportunities with 440 Artists. Pay your membership and take control of your career.',
    },
    {
        path: '/support/',
        title: 'Support & [Requests]',
        header: 'full',
        survey: 'tCFDMzfify69NomklcKJ',
        metaTitle: 'Support & Requests | 440 Artists',
        description: 'Need help with your 440 account? Reach our team for support, submit a request, or get answers about your membership and music distribution.',
    },
    {
        path: '/releaseboosters/',
        title: 'Release [Boosters]',
        header: 'full',
        survey: 'QXbP3KZNUmyBKjk7Cp5Y',
        metaTitle: 'Release Boosters | 440 Artists',
        description: 'Easily purchase your release boosters to enhance your 440 Artist experience.',
    },
    {
        path: '/music-video-promotion-asset-submission/',
        title: 'Music Video Promotion [Asset Submission]',
        header: 'full',
        survey: 'BNQXsN9kf29siZfPeDiv',
        metaTitle: 'Music Video Promotion | 440 Artists',
        description: 'Promote your music video to REVOLT’s full audience across its owned social platforms and TV networks. Subject to approval; limited to 2 releases per month.',
    },
    {
        path: '/social-post-asset-submission/',
        title: 'Social Post [Asset Submission]',
        header: 'minimal',
        survey: '8pDXBnjjm7VyO7vicuB5',
        metaTitle: 'Social Post Asset Submission | 440 Artists',
        description: 'Submit your info and assets for your Social Post release booster.',
    },
    {
        path: '/spotify-canvas-asset-submission/',
        title: 'Spotify Canvas [Asset Submission]',
        header: 'minimal',
        survey: '5cBQEyRd9JZ7MTMbq3gA',
        metaTitle: 'Spotify Canvas Asset Submission | 440 Artists',
        description: "Submit your video asset and we'll create your looping Spotify Canvas. Share a Dropbox, WeTransfer, or Google Drive link to get started.",
    },
    {
        path: '/upgrades/',
        title: 'Release [Upgrades]',
        header: 'full',
        survey: '1R0mQ5l68nz1qWRKnI3a',
        metaTitle: 'Release Upgrades | 440 Artists',
        description: 'Easily purchase your release upgrades to enhance your 440 Artist experience.',
    },
    {
        path: '/the-artist-playbook-asset-submission/',
        title: 'The Artist Playbook [Asset Submission]',
        header: 'minimal',
        survey: 'Q7Tt25jfL7QuO7NTOYC2',
        metaTitle: 'The Artist Playbook Asset Submission | 440 Artists',
        description: 'One song, full support. A dedicated Ads Manager, playlist pitching to editorial and indie curators, and a Platform Success Partner for your rollout.',
    },
];
